import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/analytics-empty-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-74ed941e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service__widget" }
const _hoisted_2 = { class: "service__wrapper" }
const _hoisted_3 = { class: "left__block" }
const _hoisted_4 = {
  key: 0,
  class: "tw-w-full tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center tw-rounded-[16px] tw-overflow-hidden tw-min-h-[350px] tw-bg-white"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "service__list"
}
const _hoisted_8 = { class: "inner__left__block" }
const _hoisted_9 = { class: "inner__right__block" }
const _hoisted_10 = { class: "right__block" }
const _hoisted_11 = { id: "revenueByServiceChart" }
const _hoisted_12 = { id: "revenueByServiceChartEmptyState" }
const _hoisted_13 = { class: "service__wrapper" }
const _hoisted_14 = { class: "left__block" }
const _hoisted_15 = {
  key: 0,
  class: "tw-w-full tw-flex tw-flex-col tw-gap-4 tw-justify-center tw-items-center tw-rounded-[16px] tw-overflow-hidden tw-min-h-[350px] tw-bg-white"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = {
  key: 1,
  class: "service__list"
}
const _hoisted_19 = { class: "inner__left__block" }
const _hoisted_20 = { class: "inner__right__block" }
const _hoisted_21 = { class: "right__block" }
const _hoisted_22 = { id: "jobDurationByServiceChart" }
const _hoisted_23 = { id: "jobDurationByServiceChartEmptyState" }

import AnalyticsWidgetLayout from "@/core/components/slots/AnalyticsWidgetLayout.vue";
import { computed, onMounted } from "vue";
import Highcharts from "highcharts";
import { useStore } from "vuex";
import { ANALYTICS_STORE } from "@/store/modules/analytics";
import CurrencyFilter from "@/filters/currency.filter";
import Text from "@/core/components/ui/general/Text.vue";
import { fa } from "element-plus/es/locale";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceCardsLayout',
  setup(__props) {

const store = useStore();

const revenueByServiceData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getRevenueByService`]
);
const jobDurationByServiceData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getJobDurationByService`]
);

const revenueandJobServiceData = computed(
  () => store.getters[`${ANALYTICS_STORE}/getRevenueAndJobService`]
);

// Helper function to generate a random vibrant color
const getRandomVibrantColor = () => {
  const hue = Math.floor(Math.random() * 360); // Random hue
  const saturation = 70 + Math.random() * 20; // High saturation (70-90%)
  const lightness = 50 + Math.random() * 10; // Medium lightness (50-60%)
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

// Default colors for the first four entries
const defaultColors = ["#FFA500", "#8D877B", "#166766", "#4F55F0"];

const getServiceRevenueData = () => {
  // const svgIconMap = {
  //   Architectural: "architecturalChart",
  //   Electrical: "electricalChart",
  //   Insulation: "insulationChart",
  //   "Gas & Heating": "gasChart",
  //   // Add any other mappings needed for service names
  // };

  // Transform the serviceRevenue object into the expected data array format
  return Object.entries(revenueandJobServiceData.value.serviceRevenue).map(
    ([serviceName, serviceData], index) => ({
      name: serviceName,
      y: serviceData.revenue,
      color: defaultColors[index] || getRandomVibrantColor(), // Use random vibrant color
      // svgIcon: svgIconMap[serviceName] || "defaultChartIcon", // Default icon if not in map
    })
  );
};

const jobDurationByServiceChartOptions = computed(() => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    plotOptions: {
      pie: {
        innerSize: "75%", // This creates the donut effect
        dataLabels: {
          enabled: true,
          useHTML: true,
          distance: 10, // Distance from the pie slice
          formatter: function () {
            // Return custom HTML content
            // return `<img src="${require(`@/assets/icons/${
            //   this.point.svgIcon + ".svg"
            // }`)}" style="width: 35px; height: 35px;" />`;
            return `<span>${this.point.name}</span>`;
          },
          align: "left", // Align the label (can be 'left', 'center', 'right')
          verticalAlign: "bottom",
        },
        borderRadius: 0,
      },
    },
    series: [
      {
        name: "Share",
        data: getServiceRevenueData(),
      },
    ],
    subtitle: {
      text: `<div ><p>Total</p><h5>${revenueandJobServiceData.value?.totalDaysWorked} Days</h5></div>`,
      useHTML: true,
      verticalAlign: "middle",
      align: "center",
    },
  };
});

const jobDurationByServiceChartOptionsEmptyState = computed(() => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      useHTML: true, // Enable HTML for custom formatting
      pointFormat: "<b>0</b>", // Custom format
      style: {
        color: "#333333", // Tooltip text color
        fontSize: "14px",
        fontWeight: "500", // Tooltip text size
      },
    },
    plotOptions: {
      pie: {
        innerSize: "75%", // This creates the donut effect
        dataLabels: {
          enabled: false,
          useHTML: true,
          distance: 10, // Distance from the pie slice
          formatter: function () {
            // Return custom HTML content
            return `<img src="${require(`@/assets/icons/${
              this.point?.svgIcon + ".svg"
            }`)}" style="width: 35px; height: 35px;" />`;
          },
          align: "left", // Align the label (can be 'left', 'center', 'right')
          verticalAlign: "bottom",
        },
        borderRadius: 0,
      },
    },
    series: [
      {
        name: "Share",
        data: [
          {
            name: "",
            y: 25,
            color: "#AEAEAE",
            svgIcon: "",
          },
          {
            name: "",
            y: 25,
            color: "#5F5F5F",
            svgIcon: "",
          },
          {
            name: "",
            y: 25,
            color: "#AEAEAE",
            svgIcon: "",
          },
          {
            name: "",
            y: 25,
            color: "#5F5F5F",
            svgIcon: "",
          },
        ],
      },
    ],
    subtitle: {
      text: `<div ><p>Total</p><h5>${revenueandJobServiceData.value?.totalDaysWorked} Days</h5></div>`,
      useHTML: true,
      verticalAlign: "middle",
      align: "center",
    },
  };
});

const revenueByServiceChartOption = computed(() => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    plotOptions: {
      pie: {
        innerSize: "75%", // This creates the donut effect
        dataLabels: {
          enabled: true,
          useHTML: true,
          distance: 10, // Distance from the pie slice
          formatter: function () {
            // Return custom HTML content
            // return `<img src="${require(`@/assets/icons/${
            //   this.point.svgIcon + ".svg"
            // }`)}" style="width: 35px; height: 35px;" />`;
            return `<span>${this.point.name}</span>`;
          },
          align: "left", // Align the label (can be 'left', 'center', 'right')
          verticalAlign: "top",
        },
        borderRadius: 0,
      },
    },
    series: [
      {
        name: "Share",
        data: getServiceRevenueData(),
      },
    ],
    subtitle: {
      text: `<div ><p>Total</p><h5>${CurrencyFilter.formatToCurrency(
        revenueandJobServiceData.value?.totalRevenue
      )}</h5></div>`,
      useHTML: true,
      verticalAlign: "middle",
      align: "center",
    },
  };
});

const revenueByServiceChartOptionEmptyState = computed(() => {
  return {
    chart: {
      type: "pie",
    },
    title: {
      text: "",
    },
    tooltip: {
      useHTML: true, // Enable HTML for custom formatting
      pointFormat: "<b>£0</b>", // Custom format
      style: {
        color: "#333333", // Tooltip text color
        fontSize: "14px",
        fontWeight: "500", // Tooltip text size
      },
    },
    plotOptions: {
      pie: {
        innerSize: "75%", // This creates the donut effect
        dataLabels: {
          enabled: false,
          useHTML: true,
          distance: 10, // Distance from the pie slice
          formatter: function () {
            // Return custom HTML content
            return `<img src="${require(`@/assets/icons/${
              this.point?.svgIcon + ".svg"
            }`)}" style="width: 35px; height: 35px;" />`;
          },
          align: "left", // Align the label (can be 'left', 'center', 'right')
          verticalAlign: "top",
        },
        borderRadius: 0,
      },
    },
    series: [
      {
        name: "Share",
        data: [
          {
            name: "",
            y: 25,
            color: "#AEAEAE",
            svgIcon: "",
          },
          {
            name: "",
            y: 25,
            color: "#5F5F5F",
            svgIcon: "",
          },
          {
            name: "",
            y: 25,
            color: "#AEAEAE",
            svgIcon: "",
          },
          {
            name: "",
            y: 25,
            color: "#5F5F5F",
            svgIcon: "",
          },
        ],
      },
    ],
    subtitle: {
      text: `<div ><p>Total</p><h5>${CurrencyFilter.formatToCurrency(
        revenueandJobServiceData.value?.totalRevenue
      )}</h5></div>`,
      useHTML: true,
      verticalAlign: "middle",
      align: "center",
    },
  };
});

onMounted(() => {
  console.log(revenueandJobServiceData.value, "revenueandJobServiceData");
  Highcharts.chart("revenueByServiceChart", revenueByServiceChartOption.value);
  Highcharts.chart(
    "revenueByServiceChartEmptyState",
    revenueByServiceChartOptionEmptyState.value
  );
  Highcharts.chart(
    "jobDurationByServiceChart",
    jobDurationByServiceChartOptions.value
  );
  Highcharts.chart(
    "jobDurationByServiceChartEmptyState",
    jobDurationByServiceChartOptionsEmptyState.value
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AnalyticsWidgetLayout, {
      class: "service__card",
      title: "Revenue by Service",
      hideToolTip: true,
      headerIcon: "revenueService",
      borderBottom: true
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!revenueandJobServiceData.value.totalRevenue)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(Text, {
                    textWeight: "500",
                    variant: "p",
                    textColor: "rgba(12, 15, 74, 0.5)",
                    lineHeight: "18px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Revenue by service will show here"),
                      _hoisted_6,
                      _createTextVNode(" when you complete jobs.")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
                    revenueandJobServiceData.value.serviceRevenue
                  ), (serviceName) => {
                      return (_openBlock(), _createElementBlock("li", { key: serviceName }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(Text, {
                            variant: "p",
                            textWeight: "600",
                            textColor: "rgba(12, 15, 74, 0.5)"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(serviceName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(Text, { variant: "p" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(CurrencyFilter).formatToCurrency(
                          revenueandJobServiceData.value.serviceRevenue[
                            serviceName
                          ].revenue.toLocaleString()
                        )), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _withDirectives(_createElementVNode("div", _hoisted_11, null, 512), [
              [_vShow, revenueandJobServiceData.value.totalRevenue]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
              [_vShow, !revenueandJobServiceData.value.totalRevenue]
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(AnalyticsWidgetLayout, {
      class: "service__card",
      title: "Job Duration by Service",
      hideToolTip: true,
      headerIcon: "jobService",
      borderBottom: true
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (!revenueandJobServiceData.value.totalDaysWorked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(Text, {
                    textWeight: "500",
                    variant: "p",
                    textColor: "rgba(12, 15, 74, 0.5)",
                    lineHeight: "18px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Job duration by service will show here"),
                      _hoisted_17,
                      _createTextVNode(" when you complete jobs.")
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(
                    revenueandJobServiceData.value.serviceRevenue
                  ), (serviceName) => {
                      return (_openBlock(), _createElementBlock("li", { key: serviceName }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(Text, {
                            variant: "p",
                            textWeight: "600",
                            textColor: "rgba(12, 15, 74, 0.5)"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(serviceName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(Text, { variant: "p" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(revenueandJobServiceData.value.serviceRevenue[serviceName]
                          .days) + " Days", 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("div", _hoisted_22, null, 512), [
              [_vShow, revenueandJobServiceData.value.totalDaysWorked]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_23, null, 512), [
              [_vShow, !revenueandJobServiceData.value.totalDaysWorked]
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})